import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
    selector: 'kt-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    public userEncoded: string;

    constructor() { }

    ngOnInit() {
        this.userEncoded = window.location.search.slice('user='.length + 1);
    }

}
